import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function RenewableAgency() {
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9; // ✅ 10 items per page

  // Fetch data from backend
  useEffect(() => {
    axios
      .get("https://backend-zkgn.onrender.com/api/renewable-agencies")
      .then((res) => {
        setAgencies(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch agencies:", err);
        setLoading(false);
      });
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(agencies.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = agencies.slice(indexOfFirst, indexOfLast);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this agency?")) return;
    try {
      await axios.delete(`https://backend-zkgn.onrender.com/api/renewable-agencies/${id}`);
      setAgencies((prev) => prev.filter((a) => a.renew_id !== id));
      toast.success("Agency deleted successfully.");
    } catch (error) {
      console.error("Error deleting agency:", error);
      toast.error("Failed to delete agency.");
    }
  };

  if (loading) return <div className="text-center mt-5">Loading...</div>;

  // 👇 Compact pagination (5 visible buttons)
  const getPageNumbers = () => {
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }

    const pages = [];
    if (start > 1) pages.push(1, "...");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages) pages.push("...", totalPages);
    return pages;
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 className="fw-bold text-tertiary mb-2">
          <strong>{agencies.length}</strong> - Renewable Agencies Found
        </h5>
        <Link to="/addrenewableagency" className="btn btn-primary">
          Add Renewable Agency
        </Link>
      </div>

      <div className="row">
        {currentItems.map((agency) => (
          <div key={agency.renew_id} className="col-lg-4 col-md-6 mb-4">
            <div className="card h-100 shadow-sm position-relative">
              <div className="card-body">
                <Link
                  className="agency-link text-decoration-none"
                  to={`/renewableagencydashboard/${agency.renew_agency_name.replace(
                    /\s+/g,
                    "-"
                  )}/${agency.renew_id}`}
                >
                  <h5 className="card-title fw-bold text-dark">
                    {agency.renew_agency_name}
                  </h5>
                </Link>
                <p className="mb-1">
                  <strong style={{ color: "#D84D10" }}>Address:</strong>{" "}
                  {agency.renew_agency_address}, {agency.renew_agency_city}
                </p>
                <p className="mb-0">
                  <strong style={{ color: "#D84D10" }}>Contact:</strong>{" "}
                  {agency.renew_agency_phone}, {agency.renew_agency_email}
                </p>
              </div>

              <div className="position-absolute bottom-0 end-0 p-2 d-flex">
                <Link
                  to={`/editrenewableagency/${agency.renew_agency_name.replace(
                    /\s+/g,
                    "-"
                  )}/${agency.renew_id}`}
                  className="btn btn-link text-success p-0 me-3"
                >
                  <i className="fa fa-edit"></i>
                </Link>
                <button
                  onClick={() => handleDelete(agency.renew_id)}
                  className="btn btn-link text-danger p-0"
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
        <ToastContainer position="top-center" autoClose={3000} />
      </div>

      {/* ✅ Compact Pagination Controls */}
      <div className="pagination-container mt-3">
        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ← Previous
        </button>

        {getPageNumbers().map((num, i) =>
          num === "..." ? (
            <span key={i} className="pagination-dots">
              ...
            </span>
          ) : (
            <button
              key={num}
              className={`pagination-btn ${
                currentPage === num ? "active" : ""
              }`}
              onClick={() => handlePageChange(num)}
            >
              {num}
            </button>
          )
        )}

        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next →
        </button>
      </div>
    </div>
  );
}

export default RenewableAgency;
